<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title"> 
                            {{ $t('tipo-agenda') }}: 
                            {{ 
                                (tipoAgenda && tipoAgenda.idtipoagendaatividade) 
                                    ? tipoAgenda.descricao 
                                    : $t('novo-tipo-agenda') 
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li><a class="a-inativo">{{$t('vendas')}}</a></li>
                                <li><a class="a-inativo">{{$t('crm')}}</a></li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-tipo-agenda-list' })">
                                    {{$t('tipos-agenda')}}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                    {{ 
                                        (tipoAgenda && tipoAgenda.idtipoagendaatividade) 
                                            ? tipoAgenda.descricao 
                                            : $t('novo-tipo-agenda') 
                                    }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button 
                            class="delete-btn" 
                            type="button"
                            @click="$router.push({ name: 'ven-tipo-agenda-list' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button 
                            v-if="(
                                (!isUpdate && permissao.create) || (isUpdate && permissao.update)
                                ) && !tipoagendaIntegracao
                            " 
                            class="save-btn" 
                            type="button" 
                            @click="save()" 
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>

                <!-- FORMULÁRIO -->
                <div class="columns is-multiline is-2 is-variable mt-4 mb-0">
                    <div class="column is-3">
                        <v-input
                            :id="generateId(1)"
                            ref="idErpInput"
                            v-model="tipoAgenda.idtipoagendaatividadeerp"
                            placeholder="placeholder-preencha"
                            :required="isUpdate"
                            :invalid="isUpdate && isNull(tipoAgenda.idtipoagendaatividadeerp)"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                            :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                            :disabled="tipoagendaIntegracao"
                        />
                    </div>
                    <div class="column is-6">
                        <v-input
                            :id="generateId(2)"
                            v-model.trim="tipoAgenda.descricao"
                            ref="descricaoInput"
                            title="descricao"
                            placeholder="descricao-do-tipo-agenda-atividade-placeholder"
                            :invalid="!tipoAgenda.descricao"
                            :maxlength="255"
                            uppercase
                            required
                            tooltipLabel="info-descricao-generica"
                            :disabled="tipoagendaIntegracao"
                        />
                    </div>
                    <div class="column is-3">
                        <vss-select
                            :id="generateId(3)"
                            ref="situacaoSelect"
                            :options="situacoes"
                            v-model="situacaoSelected"
                            :mlLabels="true"
                            title="situacao"
                            @input="updateSituacao"
                            :searchable="false"
                            class="no-clear"
                            required
                            tooltipLabel="info-situacao-generica"
                            :disabled="!isUpdate || tipoagendaIntegracao"
                        />
                    </div>
                    <div class="column is-3">
                        <IconsSelect
                            :id="generateId(4)"
                            title="icone"
                            @changeIcon="tipoAgenda.icone = $event"
                            :msg="'msg-campo-obrigatorio'"
                            :invalid="invalidIcon"
                            :iconClass="tipoAgenda.icone"
                            required
                        />
                    </div>
                    <div class="column is-3">
                        <color-picker
                            :id="generateId(5)"
                            title="selecione-uma-cor"
                            type="text"
                            :color="tipoAgenda.cor"
                            ref="cpInput"
                            @colorpicked="tipoAgenda.cor = $event"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoAgendaAtividadeService from "@/services/TipoAgendaAtividadeService";
import TipoAgendaAtividadeValidation from "@/services/validations/TipoAgendaAtividadeValidation";
import Message from "@/models/Message";
import IconsSelect from "@/components/shared/form/IconsSelect";
import ColorPicker from "@/components/shared/form/ColorPicker";

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    data() {
        return {
            tipoagendaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("TIPOAGENDAATIVIDADE"),
            id: this.$route.params.id,
            service: new TipoAgendaAtividadeService(this.$http, this.$router),
            msgs: [],
            validation: new TipoAgendaAtividadeValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            isUpdate: false,
            situacoes: [{ label: "inativo", id: 0 }, { label: "ativo", id: 1 }],
            situacaoSelected: { label: "ativo", id: 1 },
            tipoAgenda: {
                idtipoagendaatividadeerp: null,
                descricao: null,
                situacao: 1,
                icone: "",
                cor: '#D0CFCF',
            },
            invalidIcon: false,
            originalIdErp: ''
        };
    },
    created() {
        this.isUpdate = Boolean(this.$route.params.id);

        this.permissao = this.hasPermissionAccess("vendas", "crm", "ven-tipo-agenda");
        if ( (!this.isUpdate && !this.permissao.create) ){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'tipos-atividades' }
            });
        } else if (this.isUpdate) {
            this.carregarDados(this.$route.params.id);
        }
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        carregarDados(id) {
            this.isLoading = true;

            this.service.find(id)
                .then(body => {
                    if (body.content) {
                        this.tipoAgenda = body.content;
                        this.situacaoSelected = this.situacoes[this.tipoAgenda.situacao]

                        this.originalIdErp = this.tipoAgenda.idtipoagendaatividadeerp;
                    } else {
                        this.$router.push({ name: "ven-tipo-agenda-new'" });
                    }
                })
                .catch(e => {
                    console.error("Erro ao carregar tipo de atividade.", e);
                })
                .finally(_ => {
                    this.isLoading = false;
                })
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.situacaoSelected = situacao;
                this.tipoAgenda.situacao = situacao.id;
            }
        },
        save() {
            this.tipoAgenda = this.mapTosave(this.tipoAgenda);
            this.tipoAgenda.situacao = this.situacaoSelected.id
            if (
                this.validation.validate(this.tipoAgenda, this.$refs) && 
                this.tipoAgenda.icone != ""
            ) {
                if(this.isPrefixSovisInIdErpInvalid(this.tipoAgenda.idtipoagendaatividadeerp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    return this.$root.showMessage('alert', message, true);
                }

                this.invalidIcon = false;
                this.isSaving = true;

                this.service
                    .save(this.tipoAgenda)
                    .then(body => {
                        if (body.content) {
                            let msg = "msg-tipo-agenda-atividade-salva";

                            if (this.tipoAgenda.id) {
                                msg = "msg-tipo-agenda-atividade-edita";
                            }

                            this.tipoAgenda = body.content;
                            this.$root.showMessage('success', msg);
                            this.redirectToList();
                        } else {
                            this.isSaving = false;
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.tipoAgenda.idtipoagendaatividadeerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }).catch(e => {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.invalidIcon = (this.tipoAgenda.icone == "");
            }
        },
        redirectToList() {
            setTimeout(_ => this.$router.push({name: "ven-tipo-agenda-list"}), 1000);
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}

.page {
    position: relative;
    margin-bottom: 20px;
}
</style>